import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cartSlice";
import experienceReducer from "./experienceSlice";
import landingSearchReducer from "./landingSearchSlice";
import userBookingsReducer from "./userBookingsSlice";
import { loadState, saveState } from "./persist";

const preloadedState = loadState();

export const createPortalStore = (initialState) => configureStore({
  reducer: {
    cart: cartReducer,
    experience: experienceReducer,
    landingSearch: landingSearchReducer,
    userBookings: userBookingsReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  preloadedState: initialState,
});

const store = createPortalStore(preloadedState);

if (typeof window !== "undefined") {
  let persistTimer = null;
  store.subscribe(() => {
    if (persistTimer) {
      window.clearTimeout(persistTimer);
    }
    persistTimer = window.setTimeout(() => {
      const state = store.getState();
      saveState({
        userBookings: {
          items: state.userBookings?.items || [],
          lastFetchedAt: state.userBookings?.lastFetchedAt || null,
          lastParams: state.userBookings?.lastParams || null,
          status: state.userBookings?.status || "idle",
          error: state.userBookings?.error || null,
        },
        landingSearch: state.landingSearch || null,
      });
    }, 200);
  });
}

export default store;

export * from "./cartSlice";
export * from "./experienceSlice";
export * from "./userBookingsSlice";
export * from "./landingSearchSlice";

export * from "./cartSlice";
export * from "./experienceSlice";
export * from "./userBookingsSlice";
export * from "./landingSearchSlice";
